import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=3a2146d8&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports